import { render, staticRenderFns } from "./EditEmployeeFaceModal.vue?vue&type=template&id=499a10a8&scoped=true&lang=pug"
import script from "./EditEmployeeFaceModal.vue?vue&type=script&lang=js"
export * from "./EditEmployeeFaceModal.vue?vue&type=script&lang=js"
import style0 from "./EditEmployeeFaceModal.vue?vue&type=style&index=0&id=499a10a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499a10a8",
  null
  
)

export default component.exports